const packageInfo = require( '../../../package/package.json' );

export const name = packageInfo.name;
export const version = packageInfo.version;